import { render, staticRenderFns } from "./VarsayilanAvukatTalepAdresTuruPicker.vue?vue&type=template&id=0405c6f2"
import script from "./VarsayilanAvukatTalepAdresTuruPicker.vue?vue&type=script&lang=ts"
export * from "./VarsayilanAvukatTalepAdresTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports